import { render, staticRenderFns } from "./FormRegeneratorD.vue?vue&type=template&id=19a4ff05&scoped=true&"
import script from "./FormRegeneratorD.vue?vue&type=script&lang=js&"
export * from "./FormRegeneratorD.vue?vue&type=script&lang=js&"
import style0 from "./FormRegeneratorD.vue?vue&type=style&index=0&id=19a4ff05&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a4ff05",
  null
  
)

export default component.exports